/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_tariffwizard.js                                                                     */
/**********************************************************************************************************************/
/* Controller.TariffWizard */

/**
 * @class this.Controller.TariffWizard
 */
HafasWebapp.prototype.Controller.TariffWizard = {

  breadcrumbMenu: [],
  currentForm: null,    // um außerhalb von postForm eine Referenz auf das Formular zu haben; wird in renderIndex gesetzt
  currentWizardPage: null,
  currentPolyline: null,    // Luftlinie zwischen A, Vias, B

  /**
   * @class this.Controller.TariffWizard.index
   *
   * @param data
   */
  index: function () {
    Hafas.Modules.Loader.loadTemplateFiles(['tariffwizard.index.html'], Hafas.bind(function () {
      Hafas.bind(this.Controller.TariffWizard.renderIndex, this)();
    }, this));
  },

  renderIndex: function () {
    var me = this;
    if (Hafas.Modules.History)
    me.Controller.TariffWizard.GUI.cleanup();
    me.Controller.TariffWizard.instance.init({
      callback: function() {
        Hafas.bind(me.Controller.TariffWizard.showWizardPage, me)({})
      }
    });
  },

  showWizardPage: function(params) {
    var me = this;
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    if(params.fid) {
      me.Controller.TariffWizard.instance.setActiveWizardPage(params.fid);
    }
    // Aktive Wizard-Seite anzeigen, wenn keine Seite übergeben wurde
    var activeWizardObj = me.Controller.TariffWizard.instance.getWizardPage('selected', true);
    var activeWizardPage = activeWizardObj.page;
    var previousButton = Hafas.bind(me.Controller.TariffWizard.getButtonParameters, me)(activeWizardObj.idx, "previous");
    var nextButton = Hafas.bind(me.Controller.TariffWizard.getButtonParameters, me)(activeWizardObj.idx, "next");
    activeWizardPage.navButtons = {
      previous: { state: previousButton.buttonDisabledState },
      next: { state: nextButton.buttonDisabledState }
    };
    if(previousButton.hasOwnProperty('event')) {
      activeWizardPage.navButtons.previous.event = previousButton.event;
    }
    if(nextButton.hasOwnProperty('event')) {
      activeWizardPage.navButtons.next.event = nextButton.event;
    }
    if(Hafas.Config.TariffWizard.breadcrumbMenu.show) {
      activeWizardPage.breadcrumbMenu = this.Controller.TariffWizard.instance.getBreadcrumbModel({fid: activeWizardPage.fid});
    }
    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffWizard.index +++ DEBUG Model +++', activeWizardPage);
    }
    if (Hafas.Modules.History) {
      Hafas.Modules.History.addData("TariffWizard", activeWizardPage.fid, {type: "TRF_SEARCH_PAGE"});
    }

    // The date time picker is only shown in TariffWizard_TplRoute when config.TariffWizard.useDateTimePicker was set to true.
    // Therefor we check if the wizardPage or any child has the type route
    var wizardPageHasDtp = false;
    if (activeWizardPage.type === "route" && Hafas.Config.TariffWizard.useDateTimePicker === true) {
      wizardPageHasDtp = true;
    } else {
      if (activeWizardPage.elementList) {
        this.Controller.TariffWizard.currentWizardPage = activeWizardPage.elementList;
        activeWizardPage.elementList.forEach(function (childPage) {
          if (childPage.type === "route" && Hafas.Config.TariffWizard.useDateTimePicker === true) {
            wizardPageHasDtp = true;
          }
        })
      }
    }

    if (wizardPageHasDtp) {
      // Page has a date time picker, we have to track that to disable scrolling in that container, otherwise DTP activates scroll overflow
      activeWizardPage.hasDateTimePicker = true;
    }

    var formContainer = Hafas("#" + me.formContainer);
    Hafas.Modules.Render.render({
      file: 'tariffwizard.index.html',
      target: formContainer,
      template: 'TariffWizard_TplIndex',
      model: activeWizardPage
    }, Hafas.bind(function () {
      me.Controller.TariffWizard.currentForm = Hafas('#HFS_FormTariffWizard', false, formContainer);
      if(Hafas.Config.TariffWizard.breadcrumbMenu.show) {
        Hafas.bind(me.Controller.TariffWizard.initBreadcrumbs, me)(activeWizardPage.breadcrumbMenu);
      }
      Hafas.bind(me.Controller.TariffWizard.initTabGroups, me)({});
      Hafas.bind(me.Controller.TariffWizard.initRouteSelection, me)(activeWizardPage);

      var actionbar = Hafas('#TariffWizard_IndexActionbarHeaderHeader');
      if (actionbar) {
        // If we have an actionbar, hide the backButton for the first page and show it for the other pages
        var backBtn = Hafas('.hfs_back', false, actionbar);
        if (activeWizardPage.fid === "TRF_SEARCH_PAGE_0") {
          Hafas.Util.gui.setVisibility(backBtn, false);
        } else {
          Hafas.Util.gui.setVisibility(backBtn, true);
        }
      }

      if (activeWizardPage.fid === "TRF_SEARCH_PAGE_0" && Hafas.Config.TariffWizard.useDateTimePicker) {
        Hafas.bind(me.Controller.TariffWizard.initDtp, me)();
      }
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/GUI/form/show', [{}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);
    },this));
  },

  browseWizardPage: function(params) {
    var currFid = params.fid;
    var direction = params.direction;
    var pageCounter = {
      "previous": -1, // go one step back
      "next": 1       // go one step forward
    };
    var isInputValid = Hafas.bind(this.Controller.TariffWizard.checkRequiredInputs, this)(params);
    if(isInputValid) {
      var nextActiveWizardPage = this.Controller.TariffWizard.instance.getAdjacentWizardPage(currFid, pageCounter[direction]);
      // Prüfen, ob diese Seite angezeigt werden darf oder übersprungen werden muss
      if(nextActiveWizardPage.state == "ACTIVE") {
        // Seitenelemente mit state=="ACTIVE" werden als Wizard-Seiten angezeigt
        this.Controller.TariffWizard.instance.setActiveWizardPage(nextActiveWizardPage.fid);
        Hafas.bind(this.Controller.TariffWizard.showWizardPage, this)({});
      } else {
        // Seitenelemente mit state=="INACTIVE" werden als Wizard-Seiten nicht angezeigt und übersprungen
        // es wird die nächstmögliche Seite mit show=true angezeigt
        Hafas.bind(this.Controller.TariffWizard.browseWizardPage, this)({fid: nextActiveWizardPage.fid, type: direction});
      }
    }
  },

  checkRequiredInputs: function(params) {
    var currentPage = this.Controller.TariffWizard.instance.getWizardElements({parameter: "fid", value: params.fid});
    var selectedEleL = this.Controller.TariffWizard.instance.getWizardElements({parameter: "state", value: "ACTIVE", customList: currentPage[0].elementList});
    var inputIsValid = true;
    for(var selIdx = 0; selIdx < selectedEleL.length; selIdx++) {
      if(selectedEleL[selIdx].hasOwnProperty("fid")) {
        switch(selectedEleL[selIdx].fid) {
          case "TRF_SEARCH_TRIP_A_TO_B":
            inputIsValid = Hafas.bind(this.Controller.TariffWizard.validateRouteInput, this)(selectedEleL[selIdx]);
            break;
        }
      }
    }
    return inputIsValid;
  },

  validateRouteInput: function(routeElement) {
    var formValidation = Hafas.Core.newType("hafasValidation", {
      checkFormOnInit: false,
      form: this.Controller.TariffWizard.currentForm
    });
    // override default behaviour of suggest
    // Nutzer soll nur mit gültigen Locations weiter navigieren können
    var overrides = formValidation.overrides;
    formValidation.locations = {
      depLoc: this.Controller.TariffWizard.instance.getLocation("dep"),
      arrLoc: this.Controller.TariffWizard.instance.getLocation("arr")
    };
    overrides.checkForm = function() {
      var instance = formValidation;
      instance.resetFields();

      var i = 0,
          len = instance.elements.length;

      for (i; i < len; i++) {
        var el = instance.elements[i];

        if (el.getAttribute('required')) {

          if (el.value === '') {
            instance.valid = false;
            instance.showError(el, 'required');
          } else {
            if (el.getAttribute('pattern')) {
              var re = new RegExp(el.getAttribute('pattern'), 'g');
              if (!el.value.match(re)) {
                instance.valid = false;
                instance.showError(el, 'pattern');
              }
            }
          }
          if((el.name == "from") && (instance.locations.depLoc == null)) {
            instance.valid = false;
            instance.showError(el, 'required');
          }
          if((el.name == "to") && (instance.locations.arrLoc == null)) {
            instance.valid = false;
            instance.showError(el, 'required');
          }
        }
        if (el.getAttribute('pattern')) {
          var re = new RegExp(el.getAttribute('pattern'), 'g');
          if (!el.value.match(re)) {
            this.valid = false;
            instance.showError(el, 'pattern');
          }
        }
      }
    };

    formValidation.checkForm();
    var isValid = formValidation.valid;
    return isValid;
  },

  showResultOverview: function (data) {
    var me = this;
    Hafas.Modules.History.addOrUpdateData("TariffWizard", "overview", data);

    if (!Hafas.Config.showFormOnResult) {
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TariffWizard'}]);
    }

    var filterInfo = Hafas.Util.Tariffs.resolveFilterProperties(data.fareSetL);
    this.Controller.TariffWizard.filterInfo = filterInfo;

    data.fareSetL.forEach(function (fareSet) {
      fareSet.fareL.forEach(function (fare) {
        if (fare.infoExt && fare.infoExt.content && fare.infoExt.content.content) {
          fare.infoExt.content.contentResolved = Hafas.Util.b64DecodeUnicode(fare.infoExt.content.content);
        }
      });
    });

    // FareSets alle initial anzeigen
    for (var d = 0; d < data.fareSetL.length; d++) {
      data.fareSetL[d].showInitially = Hafas.Config.TariffWizard.showFaresetsInitially;
    }

    var model = {
      tariffInfoBox: {
        fareSetListResolved: data.fareSetL
      },
      showFilter: filterInfo.filterFound,
      filter: Hafas.Util.Tariffs.getDefaultTariffFilter(this.Controller.TariffSearch.tariffFilter, filterInfo.foundFilters, 'tariffsearch'),
      ctx: 'tariffwizard'
    };
    if (typeof data.variantL != 'undefined') {
      model.variantList = data.variantL;
    } else {
      model.variantList = [];
    }
    if(typeof data.bkgData != 'undefined'){
      model.bkgData = data.bkgData;
    }
    model.viewHeader = {
      overview: Hafas.Modules.i18n.get('TariffSearch.index.t_N_Overview')
    };

    Hafas.ps.pub('/GUI/results/overview/show', [{}]);

    // is defined in classic-Version GUI-Functions
    Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

    this.Controller.TariffWizard.currentView = "overview";

    // HDPWAPP-8254: Customer Changes
    // Adding a new tariff page to include a "Previous" button for navigation.
    model.fid= "TRF_SEARCH_PAGE_3"
    model.navButtons= {
      previous : {
        state: false
      }
    }
    // End customer Changes
    Hafas.Modules.Loader.loadTemplateFiles(['tariffs.index.html', 'tp.result.detail.html'], Hafas.bind(function () {
      Hafas.Modules.Render.render({
        file: 'tariffwizard.result.overview.html',
        target: 'TariffWizard_ResultOverview',
        template: 'TariffWizard_TplOverview',
        model: model
      }, Hafas.bind(function () {

        if (model.variantList.length > 0) {
          var tmpSelectBox = Hafas.Core.newType('HafasSelectBox', {
            holder: 'HFS_TariffSearchVariantList_Holder', callback: function (data) {
              Hafas.ps.pub('/tariffsearch/chooseVariant', [decodeURIComponent(data.value)]);
            }
          });
          tmpSelectBox.initiate();
          this.Controller.TariffWizard.tariffSelectBoxes.push(tmpSelectBox);
        }

        if (filterInfo.filterFound) {
          Hafas.bind(me.Controller.TariffSearch.updateTariffFilterResults, me)(filterInfo.foundFilters);
        }

        Hafas.bind(me.Controller.TariffWizard.GUI.showPolyline, me)();

        Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
        Hafas.ps.pub('/app/events/resize');
      }, this));
    }, this));
  },

  showErrorPage: function (data) {
    if (!Hafas.Config.showFormOnResult) {
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'TariffWizard'}]);
    }

    Hafas.Modules.History.addOrUpdateData("TariffWizard", "error", data);

    Hafas.ps.pub('/GUI/results/overview/show', [{}]);

    var model = {};
    model.viewHeader = {
      overview: Hafas.Modules.i18n.get('TariffSearch.index.t_N_Overview')
    };
    model.statusText = data.statusText;

    this.Controller.TariffSearch.currentView = "overview";

    Hafas.Modules.Render.render({
      file: 'tariffwizard.result.overview.html',
      target: 'TariffWizard_ResultOverview',
      template: 'TariffWizard_ErrorTpl',
      model: model
    }, Hafas.bind(function () {

      Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  getButtonParameters: function(activePageIndex, direction) {
    var buttonParam = {
      buttonDisabledState: true
    };
    var pageList = this.Controller.TariffWizard.instance.getWizardPageList();
    var pageIdx = activePageIndex;
    if(direction == "previous") {
      // enable button "previous" if there is a page with show=true before the active page
      while(pageIdx > 0) {
        pageIdx--;
        if(pageList[pageIdx].state == "ACTIVE") {
          buttonParam.buttonDisabledState = false;
        }
      }
    }

    if(direction == "next") {
      // "next"-Button is always enabled
      buttonParam.buttonDisabledState = false;
      var isLastWizardPage = true;
      // find out if this is the last page before result page
      while(pageIdx < (pageList.length - 1)) {
        pageIdx++;
        // there is still a page after this page
        if(pageList[pageIdx].state == "ACTIVE") {
          isLastWizardPage = false;
        }
      }
      if(isLastWizardPage) {
        // Trigger a tariff search via the "next" button after the last wizard page
        buttonParam.event = "Hafas.ps.pub('/tariffwizard/search', [{}]);";
      }
    }
    return buttonParam;
  },

  initBreadcrumbs: function(breadcrumbMenu) {
    var content = breadcrumbMenu.map(function (breadcrumb) {
      return {
        text: breadcrumb.label,
        event: function() { Hafas.ps.pub('/tariffwizard/page/show', [{fid: breadcrumb.fid}])}
      };
    });

    var breadcrumbsConf = {
      use: true,
      title: Hafas.Modules.i18n.get('TariffWizard.index.t_N_previousSelection'),
      toggleClass: 'shown',
      trigger: ['clickLeft'],
      stickTo: 'bottom|left',
      content: content
    };

    Hafas('.lyr_trfwizBreadcrumbMenuTrigger', true).forEach(function (elem) {
      Hafas.Core.newType('HafasContextMenu', breadcrumbsConf).addTo(elem);
    });
  },

  initTabGroups: function(params) {
    // init tabgroup from params
    if(params.hasOwnProperty('holder')) {
      var data = {
        holder: params.holder
      };
      if(params.hasOwnProperty('callback')) {
        data.callback = params.callback;
      }
      Hafas.Core.newType('HafasSegmentedControl', data).initiate();
    } else {
      // init all available tabgroups
      var tabgroups = this.Controller.TariffWizard.instance.getWizardElements({parameter: "type", value: "tabgroup"});
      for(var gIdx = 0; gIdx < tabgroups.length; gIdx++) {
        var tabgroupWrapper = Hafas("#" + tabgroups[gIdx].fid + "_Wrapper");
        if(tabgroupWrapper != null) {
          Hafas.Core.newType('HafasSegmentedControl', {holder: tabgroups[gIdx].fid + "_Wrapper"}).initiate();
        }
      }
    }
  },

  initRouteSelection: function(activePage) {
    var me = this;
    var routeElement = this.Controller.TariffWizard.instance.getWizardElements({parameter: "fid", value: "TRF_SEARCH_TRIP_A_TO_B", customList: activePage.elementList});
    if(routeElement.length > 0) {
      var inputFields = routeElement[0].inputFields;
      if (Hafas.Config.debug.showDataModel) {
        console.log('+++ TariffWizard.initRouteSelection.inputFields +++ DEBUG Model +++', inputFields);
      }
      var baseConfigTariffWizard = {};
      baseConfigTariffWizard.minChar = Hafas.Config.TariffWizard.Suggest.minChar;
      baseConfigTariffWizard.useNearLocation = false;
      baseConfigTariffWizard.useChooseFromMap = false;
      baseConfigTariffWizard.useHistoryLocations = 'NONE';
      for(var ident in inputFields) {
        if(ident == "Via") {
          // iterate through viaList
          for(var vIdx = 0; vIdx < inputFields[ident].viaList.length; vIdx++) {
            var viaInput = inputFields[ident].viaList[vIdx];
            initSuggest(viaInput);
          }
        } else {
          initSuggest(inputFields[ident]);
        }
      }
      function initSuggest(input) {
        var currentInput = input;
        var currentType = currentInput.type;
        var inputName = "inp" + currentInput.id;
        baseConfigTariffWizard.locType = currentType;
        // check if route form is active
        if((Hafas("#HFS_FormTariffWizard") != null) && (Hafas("#TariffWizard_" + currentInput.id) != null)) {
          me.Controller.TariffWizard[inputName] = Hafas.Core.newType('hafasSuggest', {
            loc: "TariffWizard_" + currentInput.id,
            config: baseConfigTariffWizard,
            suggestType: currentInput.suggestType,
            type: "S",
            onClear: function () {
              Hafas.ps.pub('/map/clearLocationMarker', [currentType]);
            }
          });
          var tmpLoc = me.Controller.TariffWizard.instance.getLocation(currentType);
          if (tmpLoc != null) {
            me.Controller.TariffWizard[inputName].setLocation(tmpLoc);
            // Beim Initialisieren des Formulars müssen übergebene Locations ggf. ins TariffWizard-Datenmodell übertragen werden
            me.Controller.TariffWizard.instance.modifyWizardElementByFid("TRF_SEARCH_TRIP_A_TO_B", "route", currentType);
          }
        }
      }
    }
  },

  initDtp : function() {
    var me = this;
    var dateTimePickerConfig = {
      holder: "HFS_TariffWizardDateTimePickerHolder",
      id: "TariffWizardDTP",
      config: {
        useDepArrSwitch: false,
        useTimePicker: Hafas.Config.TariffWizard.useTimePicker,
        useDatePicker: true,
        useNowMode: true,
        useInvertedClickArea: true,
        useDateTexts: true
      },
      current: {
        date: me.Controller.TariffWizard.instance.getTravelDate(),
        time: '000000',
        enquiry: false,
        isNowMode: me.Controller.TariffWizard.instance.getTimeNow()
      }
    };
    me.Controller.TariffWizard.dateTimePicker = Hafas.Core.newType('hafasTimeDatePicker', dateTimePickerConfig);
  },
  // Wenn nichts mehr im Inputfeld eingegeben wurde, Location auch aus Datenobjekt löschen
  clearLocationFromData: function(params) {
    var currentType = params.type;
    var inputName = "inpFrom";
    if(currentType == "arr") {
      inputName = "inpTo";
    } else if(currentType == "via") {
      inputName = "inpVia" + params.idx;
    }
    var typeUpperCase = currentType.charAt(0).toUpperCase() + currentType.slice(1);
    if(this.Controller.TariffWizard[inputName].inp.value.length == 0) {
      var clearFuncName = "clear" + typeUpperCase;
      try {
        if(params.hasOwnProperty("idx")) {
          this.Controller.TariffWizard.instance[clearFuncName](params.idx);
        } else {
          this.Controller.TariffWizard.instance[clearFuncName]();
        }
        Hafas.ps.pub('/tariffwizard/route/select', [{value: currentType, type: 'route', parent: "TRF_SEARCH_TRIP_A_TO_B"}]);
      } catch (e) {
        Hafas.logger.warn(Hafas.logger.ERROR_TYPES.JS, "tariffwizard." + clearFuncName, typeUpperCase + "-Eingabefeld konnte nicht geleert werden.", e);
      }
    }
  },

  validateSelection: function (type, locId, loc) {
    // location setzen
    this.Controller.TariffWizard.instance.setLocation(type, loc);
    var callback = Hafas.bind(function() {
      Hafas.Core.newType("hafasValidation", {
        form: this.Controller.TariffWizard.currentForm
      });
      Hafas.ps.pub('/tariffwizard/route/select', [{value: type, type: 'route', parent: "TRF_SEARCH_TRIP_A_TO_B"}]);
    }, this);
    this.Controller.TariffWizard.validate([locId], callback);
  },

  validate: function (data, callback) {
    if (data[0] == 'From') {
      var locationId = 'dep';
    } else if (data[0] == 'To') {
      var locationId = 'arr';
    } else if (data[0] == 'Via0') {
      var locationId = 'via';
    } else if (data[0] == 'Via1') {
      var locationId = 'via';
    }

    var location = this.main.Controller.TariffWizard.instance.getLocation(locationId);
    if (this.main.Controller.TariffWizard['inp' + data[0]].getInputText().length == 0) {
      this.main.Controller.TariffWizard.instance.setLocation(locationId, null);
    }
    if ((this.main.Controller.TariffWizard['inp' + data[0]].getInputText().length > 0) && ((location == null) || (this.main.Controller.TariffWizard['inp' + data[0]].getInputText() != location.name))) {
      this.main.Controller.TariffWizard['inp' + data[0]].validateLocation(true, Hafas.bind(function () {
        data.shift();
        if (data.length > 0) {
          this.main.Controller.TariffWizard.validate(data, callback);
        } else {
          callback();
        }
      }, this));
    } else {
      data.shift();
      if (data.length > 0) {
        this.main.Controller.TariffWizard.validate(data, callback);
      } else {
        callback();
      }
    }
    return false;
  },

  /**
   * set one element selected and deselect other elements in the tariff wizard data model
   * also Updates GUI afterwards
   * for option lists ("optiongroup") and segmented controls ("tabgroup")
   * @method modifyWizardElementByFid
   * @param {string} params.parent: filter-id aus der client filter list
   * @param {string} params.type: "option" / "tab" / "route" ...
   * @param {string} value: the value of the option/tab to be activated
   */
  setSelectedWizardElement: function(params) {
    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffWizard.setSelectedWizardElement +++ DEBUG Model +++', params);
    }
    // trigger element events if there are any
    Hafas.bind(this.Controller.TariffWizard.triggerElementEvents, this)({value: params.value});
    // modify the given element
    this.Controller.TariffWizard.instance.modifyWizardElementByFid(params.parent, params.type, params.value);
    // re-render page
    Hafas.bind(this.Controller.TariffWizard.showWizardPage, this)({});
  },

  /**
   * trigger events for elements (one element changes another element)
   * available for "state" parameter only
   * @method triggerElementEvents
   * @param {object} param
   * @param {string} params.value: given param.value is trigger of another element
   */
  triggerElementEvents: function(params) {
    // check if selected option is supposed to change the state of another option
    // this is the case if the given param.value is trigger in the event list of another element
    var eventElements = this.Controller.TariffWizard.instance.getWizardEvents({value: params.value});
    for(var eleIdx = 0; eleIdx < eventElements.length; eleIdx++) {
      // set all children of the event parent to their default state
      var childElements = eventElements[eleIdx].parent.elementList;
      for(var childIdx = 0; childIdx < childElements.length; childIdx++) {
        this.Controller.TariffWizard.instance.modifyWizardElementByFid(childElements[childIdx].fid, "state", "HIDDEN");
      }
      // apply the events in the event list
      var eventList = eventElements[eleIdx].events;
      for(var evsIdx = 0; evsIdx < eventList.length; evsIdx++) {
        this.Controller.TariffWizard.instance.modifyWizardElementByFid(eventList[evsIdx].setParent, "state", eventList[evsIdx].toState);
      }
    }
    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffWizard.triggerElementEvents +++ DEBUG Model +++', params, this.Controller.TariffWizard.instance.data.pageList);
    }
  },

  /**
   * Instant search function for quickselection option
   * @method triggerElementEvents
   * @param {object} param
   * @param {string} params.value: the value that triggers the instant search
   */
  triggerInstantSearch: function(params) {
    // es wird eine Suche nur mit diesem Value getriggert

  },

  setSelectedRoute: function(params) {
    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffWizard.setSelectedRoute +++ DEBUG Model +++', params);
    }
    this.Controller.TariffWizard.instance.modifyWizardElementByFid(params.parent, params.type, params.value);
    var parentElements = this.Controller.TariffWizard.instance.getWizardElements({parameter: "fid", value: params.parent});
    var parentElement = parentElements[0];
    // Der Route untergeordnete, optionale Buttons wie "Rückfahrt hinzufügen" oder "Via hinzufügen" werden sichtbar gemacht,
    // wenn Start und Ziel der Route eingegeben wurden (entspricht MODE="INC" der Route)
    if(parentElement.hasOwnProperty('elementList')) {
      for(var eleIdx = 0; eleIdx < parentElement.elementList.length; eleIdx++) {
        if(parentElement.mode == "INC") {
          parentElement.elementList[eleIdx].state = "ACTIVE";
        } else {
          parentElement.elementList[eleIdx].state = "HIDDEN";
        }
      }
    }
    Hafas.bind(this.Controller.TariffWizard.showWizardPage, this)({});
  },

/*  setLocation: function (type, location) {
    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ TariffWizard.setLocation +++ DEBUG Model +++', type, location);
    }
    this.Controller.TariffWizard.instance.setLocation(type, location);
    if (type == "dep")
      this.Controller.TariffWizard.inpFrom.setLocation(location);
    else if (type == "arr")
      this.Controller.TariffWizard.inpTo.setLocation(location);
  },*/

  setLocationValue: function(type, location) {
    var me = this;
    var locationName = '';
    if (location != null) {
      locationName = Hafas.Util.getLocationAttribute(location, "name");
    }

    var input = null;

    if (me.appContext === 'TariffWizard') {
      if (type == "dep") {
        input = Hafas('#TariffWizard_From', false);
      } else if (type == "arr") {
        input = Hafas('#TariffWizard_To', false);
      }
    }


    // only set value if it's different to the current one
    if (input != null && input.value !== locationName) {
      input.value = locationName;

      if (locationName) {
        // find matching label for screenreader announcement
        var label = (Hafas('label[for="' + input.id + '"]') || {});
        Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
          element: (label.textContent || Hafas.Modules.i18n.get('common.label.t_N_Unknown')),
          text: locationName
        }));
      }
      this.Controller.TariffWizard.instance.setLocation(type, location);
      Hafas.ps.pub('/tariffwizard/route/select', [{value: type, type: 'route', parent: "TRF_SEARCH_TRIP_A_TO_B"}]);
    }

    if (me.appContext != 'TariffWizard') {
      Hafas.ps.pub('/app/switchContext', [{context: 'TariffWizard', method: 'index'}]);
    }
  },

  setPageToSelected: function(fid) {
    var switchedPage = false;
    if (fid != "TRF_SEARCH_PAGE_0") {
      var pageList = this.Controller.TariffWizard.instance.data.pageList;
      for(var pageIdx = 0; pageIdx < pageList.length; pageIdx++) {
        if (pageList[pageIdx].fid == fid) {
          this.Controller.TariffWizard.instance.data.pageList[pageIdx].selected = true;
        }
      }
      this.Controller.TariffWizard.instance.data.pageList[0].selected = false;
    }
  },

  jumpinFromTripPlanner: function(params) {
    var startLocation = null;
    var destLocation = null;
    var viaLocation = null;

    if (params.dep) {
      startLocation = Hafas.Modules.Render.objectKeeper.get(params.dep);
    }
    if (params.arr) {
      destLocation = Hafas.Modules.Render.objectKeeper.get(params.arr);
    }
    // adds via if type is a station
    if (this.Controller.TP.instance.data.query.viaLocL[0].loc.type === "S") {
      viaLocation = this.Controller.TP.instance.data.query.viaLocL[0].loc;
    }

    if (startLocation != null) {
      if (startLocation.type === "S") {
        this.Controller.TariffWizard.instance.setLocation("dep", startLocation);
      } else {
        alert(Hafas.Modules.i18n.get("TariffWizard.error.t_N_noStartAddressAllowed"));
      }
    }
    if (destLocation != null) {
      if (destLocation.type === "S") {
        this.Controller.TariffWizard.instance.setLocation("arr", destLocation);
      } else {
        alert(Hafas.Modules.i18n.get("TariffWizard.error.t_N_noDestAddressAllowed"));
      }
    }
    if (viaLocation != null) {
      this.Controller.TariffWizard.instance.setLocation("via", viaLocation);
    }

    // Reset the date, since there is currently no mechanism to take over the date from the connection,
    // otherwise an earlier searched date could be used again
    this.Controller.TariffWizard.instance.setTravelDate(null);
    this.Controller.TariffWizard.instance.setTravelTime(null);

    //set second page to selected so that showWizardPage shows directly the second page from jumpin
    this.Controller.TariffWizard.instance.modifyWizardPage("TRF_SEARCH_PAGE_0","selected",false);
    this.Controller.TariffWizard.instance.modifyWizardPage("TRF_SEARCH_PAGE_1","selected",true);
  },

  // HDPWAPP-8254: Customer Changes
  jumpOut: function (params){
    Hafas.ps.pub('/common/openURL', [{url: params.url, target:'_self'}]);
    Hafas.bind(this.Controller.TariffWizard.resetTariffWizardForm, this)();
  },

  openLibTariffWizard: function(params) {
    Hafas.bind(this.Controller.TariffWizard.resetTariffWizardForm, this)();
    Hafas.ps.pub('/common/openLibTariff',[params.objectKeeperReference, params.bkgDataKeeperReference])
  },
  resetTariffWizardForm: function() {
    //As outlined in ticket HDPWAPP-8254, the Tariff Wizard form should only be reset on the native app.
    // Therefore, we need to check the URL to determine if the Tariff Wizard is being opened as a client.
    // This way, the new changes will be applied without affecting the desktop version.
    var isStandaloneTariffWizard = Hafas.Util.getUrlParams("L");
    if(Hafas.Util.getPlatform().isMobile && isStandaloneTariffWizard !== null){
      var _me = this;
      setTimeout(() => {
        Hafas.bind(_me.Controller.TariffWizard.browseWizardPage, this)({fid: 'TRF_SEARCH_PAGE_1', direction: 'previous'});
      }, 1000);
    }
  },
  // End customer Changes
  selectDateTimeFromPicker: function (hciDate, hciTime, enquiry, setTimeNow) {
    this.Controller.TariffWizard.instance.setTravelDate(hciDate);
    if(this.Controller.TariffWizard.instance.data.showTimeInGui) {
      this.Controller.TariffWizard.instance.setTravelTime(hciTime);
    }
    this.Controller.TariffWizard.instance.setTimeNow(setTimeNow);
  },

  /**
   * get vias from hafasSuggest and store them in the 'viasStoredInMemory' array within the TariffWizard controller.
   * If no vias are provided, an empty object is stored.
   * @param {Object} params - The parameters stored in this controller.
   */
  setLocationFromSuggest: function (params) {
    if (params.loc != null) {
      this.Controller.TariffWizard.instance.setLocation(params.type, params.loc);
      if (params.type === "via") {
        var viaInput = Hafas("#" + params.id, false);
        var viaParent = viaInput?.closest('.lyr_tpFromInput');
        viaParent?.closest('.lyr_tpFromInput')?.removeAttribute('hidden');
        Hafas.bind(this.Controller.TariffWizard.GUI.addVia, this)({callShowWizardPage: false});
      }
    }
  },

  GUI: {
    // Sichtbar machen von Via-Eingabefeldern in der GUI
    addVia: function(params) {
      var parentElementArr = this.Controller.TariffWizard.instance.getWizardElements({parameter: "fid", value: params.parent});
      if (!params.parent) {
        parentElementArr = this.Controller.TariffWizard.currentWizardPage;
      }
      var parentElement = parentElementArr[0];
      var viaList = parentElement.inputFields.Via.viaList;
      var currentIdx = 0;
      var viaLength = viaList.length;
      var activated = false;
      var deactivateViaButton = false;
      while((currentIdx < viaLength) && !activated) {
        var currentVia = viaList[currentIdx];
        // Via-Eingabefelder werden nacheinander mit jedem Button-Klick aktiviert/angezeigt
        if(currentVia.state == "HIDDEN") {
          currentVia.state = "ACTIVE";
          activated = true;
        }
        if(currentIdx == (viaLength - 1)) {
          deactivateViaButton = true;
        }
        currentIdx++;
      }
      // Wenn alle möglichen Vias bereits angezeigt werden, wird der "Via-Hinzufügen-Button" deaktiviert
      if(deactivateViaButton) {
        parentElement.inputFields.Via.option.state = "INACTIVE";
      }
      if (!params.callShowWizardPage) {
        var addViaBtn = Hafas('.lyr_trfwizRouteButtonAdditional', false);
        addViaBtn?.setAttribute("disabled", true);
      } else {
        Hafas.bind(this.Controller.TariffWizard.showWizardPage, this)({});
      }
    },
    closeView: function (histData) {
      console.log("+++ close view +++", histData);
      switch (histData.view) {
        case "overview":
          this.Controller.TariffWizard.instance.updateQuery({instantSearch: false});
          Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
          break;
      }
    },
    restoreView: function (histData) {
      console.log("+++ restore view +++", histData);
      var view = histData.view;
      if(histData.data.type == "TRF_SEARCH_PAGE") {
        view = histData.data.type;
      }
      switch (view) {
        case "TRF_SEARCH_PAGE":
          if (this.Controller.TariffWizard.currentPolyline) {
            this.Controller.Map.instance.hideContent(this.Controller.TariffWizard.currentPolyline);
            this.Controller.Map.instance.removeContent(this.Controller.TariffWizard.currentPolyline);
            this.Controller.TariffWizard.currentPolyline = null;
          }
          Hafas.bind(this.Controller.TariffWizard.showWizardPage, this)({fid: histData.view});
          break;
        case "overview":
          Hafas.ps.pub('/GUI/form/hide', [{}]);
          Hafas.bind(this.Controller.TariffWizard.showResultOverview, this)(histData.data);
          break;
      }
    },
    showPolyline: function () {
      var map = this.Controller.Map.instance;
      if (map) {
        var queryData = this.Controller.TariffWizard.instance.data.query;
        var coords = [];

        coords.push(Hafas.Core.newType("hafasCCoord", {
          lon: queryData.depLocL[0].crd.x,
          lat: queryData.depLocL[0].crd.y
        }));

        queryData.viaLocL.forEach(function (via) {
          coords.push(Hafas.Core.newType("hafasCCoord", {
            lon: via.crd.x,
            lat: via.crd.y
          }));
        });

        coords.push(Hafas.Core.newType("hafasCCoord", {
          lon: queryData.arrLocL[0].crd.x,
          lat: queryData.arrLocL[0].crd.y
        }));

        var param = {
          type: 'polyline',
          onmouseover: function () {
          },
          color: Hafas.Config.Styling.PrimaryClr,
          coords: coords,
          width: Hafas.Config.Maps.DEFAULT_POLYLINE_WIDTH,
          opacity: Hafas.Config.Maps.DEFAULT_POLYLINE_OPACITY,
          border: Hafas.Config.Maps.useLineBorders,
          scaleOnZoom: true
        };
        var polyline = map.createContent(param);
        map.showContent(polyline);
        this.Controller.TariffWizard.currentPolyline = polyline;
      }
    },
    cleanMap: function () {
      if (typeof this.Controller.Map != 'undefined') {
        this.Controller.Map.hideConnection();
        this.Controller.Map.hideTripMarker();
      }
    },
    cleanup: function () {
      var overviewElement = Hafas('#TariffWizard_ResultOverview', false);
      if(overviewElement) {
        overviewElement.innerHTML = '';
      }
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/hide', [{}]);
      Hafas.ps.pub('/GUI/form/hide', [{}]);
    }
  },
  clearInput: function() {
    this.Controller.TariffWizard['inpFrom'].resetLocation();
    this.Controller.TariffWizard['inpTo'].resetLocation();
    var viaIndex = 0;
    var currentViaSuggest = this.Controller.TariffWizard['inpVia' + viaIndex];
    while (currentViaSuggest) {
      currentViaSuggest.resetLocation();
      this.Controller.TariffWizard.instance.clearVia(viaIndex);
      currentViaSuggest = this.Controller.TariffWizard[`inpVia${++viaIndex}`];
    }
    this.Controller.TariffWizard.instance.clearDep();
    this.Controller.TariffWizard.instance.clearArr();

    Hafas.ps.pub('/GUI/clearMap/TariffWizard', []);

    Hafas.ps.pub('/app/switchContext', [{context: 'TariffWizard', method: 'index'}]);

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  }
};
